// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2615":"fc854c75","3803":"fc854c75"}[chunkId] + ".chunk.css";
};